import { createContext, useContext } from "react";
import type { IncrementView, SequenceView } from "@services/drybulkCargoOperationsApi";

export type ExecutionKind = "equipment" | "start" | "add" | "complete";

export interface ActiveExecution {
  kind: ExecutionKind;
  sequence: SequenceView;
  /** The open increment a Complete finishes. */
  increment?: IncrementView;
}

export interface ExecutionContextValue {
  active: ActiveExecution | null;
  open: (kind: ExecutionKind, sequence: SequenceView, increment?: IncrementView) => void;
  close: () => void;
}

/** DBCO-0048 - which execution panel or dialog is open; the row-action items set it, `ExecutionDialogs` shows it. */
export const ExecutionContext = createContext<ExecutionContextValue>({
  active: null,
  open: () => undefined,
  close: () => undefined,
});

export const useExecution = (): ExecutionContextValue => useContext(ExecutionContext);
